import vueTape from 'vue-tape';
import { genUrl } from "../utils/query"

// custom config
let _custom_config = {};

// env
const _envConfig = {
  PROD: process.env.VUE_APP_CURRENTMODE == 'prod',
  QR_CODE_URL: `${process.env.VUE_APP_SERVER_HOST}/qr_image`,
  API_SERVER: `${process.env.VUE_APP_SERVER_HOST}/api`,
}

export function setCustomConfig(configValues) {
  _custom_config = configValues;
}

export function getConfig(key, def) {
  return vueTape.get(_custom_config, key,
    vueTape.get(_envConfig, key, def));
}

export function getQrCodeUrl(text) {
  return genUrl(getConfig("QR_CODE_URL", ""), { text })
}
